/*---------------------------------------------------------------------------------------------
 *  Example Custom Component Code: Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import Globals from "../../shared/Globals";
import BaseCom from "../BaseCom";

export default class Appointment extends BaseCom {



    // PREVIEW
    // This is what is displayed in the builder
    // Top level element must have:
    // style={Globals.preprocessStyleObject(this.props.col.style)}
    // className={this.props.col.className}
    // You can append additional classes to the className, don't forget to add a space before or after
    render() {
        return (
            <div className={'text-center p-4 bg-light ' + this.props.col.className}
                style={Globals.preprocessStyleObject(this.props.col.style)}>
                <label className="form-label">Enter your Zip Code</label>
                <input type="text" className="form-control" />
                <div className="d-grid gap-1 mt-3">
                    <button type="button" className="btn btn-primary">Continue</button>
                </div>
            </div>
        );
    }
}